import {Component, NgModule}      from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {CommonModule} from '@angular/common';
import { HttpModule } from '@angular/http';

import {AppComponent}  from './app.component';
import {IndexComponent} from './component/index.component';
import {SlickSliderComponent} from './component/slick-slider.component';

@NgModule({
    imports: [
        BrowserModule,
        CommonModule,
        HttpModule
    ],
    declarations: [AppComponent, IndexComponent, SlickSliderComponent],
    bootstrap: [AppComponent]
})

export class AppModule {
}



// WEBPACK FOOTER //
// ./assets_dev/ts/app/app.module.ts